var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.component)?_c('b-form-group',{attrs:{"label":_vm.title,"label-for":_vm.id}},[_c(_vm.component,{tag:"component",attrs:{"id":_vm.id,"data":_vm.data,"value":_vm.value},on:{"input":_vm.updateValue}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }